import LayoutAlert from "./components/LayoutAlert";
import "./../../pages/mockup/mockupStyles.css";
import AppHeaderContainer from "./components/AppHeaderContainer";
import AnnouncementsPopup from "./components/announcements/AnnouncementsPopup";
import { useEffect, useState } from "react";
import { getCache } from "../../utils/PersistenceUtils";
import { CompanyAuth } from "../../entities/login/CompanyAuth";
import { TranslationService } from "../../services/TranslationService";
import CompanyService from "../../services/CompanyService";
import { isFeatureEnabled } from "../../utils/featureFlags";

const Layout: React.FC = () => {
  const [firstLoad, setFirstLoad] = useState(true);
  const companyAuth = CompanyService.getCompanyAuth();
  const customerField = companyAuth?.customerFieldName || "";
  const customersField = companyAuth?.customersFieldName || "";

  useEffect(() => {
    if (firstLoad) {
      if (
        companyAuth &&
        customerField.length > 0 &&
        customersField.length > 0
      ) {
        const customerFieldName =
          getCache<CompanyAuth>("company_auth")?.customerFieldName || "";
        const customersFieldName =
          getCache<CompanyAuth>("company_auth")?.customersFieldName || "";
        TranslationService.setCurrentLanguageReplace(
          TranslationService.currentLanguage,
          customerFieldName,
          customersFieldName
        );
      }
      setFirstLoad(false);
    }
  }, [customerField.length, customersField.length, firstLoad, companyAuth]);

  return (
    <>
      <LayoutAlert />
      {!firstLoad && <AppHeaderContainer />}
      {/* TODO(GDC-5174): quitar la condición al integrar el backend de comunicados. */}
      {!firstLoad && isFeatureEnabled("announcements") && (
        <AnnouncementsPopup />
      )}
    </>
  );
};

export default Layout;
